import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceTechnicalLevelLookupComponent } from './service-technical-level-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [ServiceTechnicalLevelLookupComponent],
  exports: [ServiceTechnicalLevelLookupComponent]
})
export class ServiceTechnicalLevelLookupModule { }
